export default __webpack_public_path__ + "static/media/mini.27ce13d2.svg";